import React from "react";
import '../Css/Privacy Policy.css'

function privacyPolicy(){
    return(
        <section>
            <div class="container mt-5">
                <div class="row">
                    <div class="col-12">
                        <h1>Privacy Policy</h1>
                        <p>At 4 Wheel Barbers, we are committed to protecting and respecting your privacy. This Privacy Policy outlines how we collect, use, and protect your personal information when you use our mobile barbering services.</p>
                        
                        <h2>Information We Collect</h2>
                        <p>We may collect and process the following personal data from you:</p>
                        
                        <ul>
                        <li>Your name</li>
                        <li>Contact details (phone number, email address)</li>
                        <li>Location data for service appointments</li>
                        <li>Payment details for processing transactions</li>
                        </ul>

                        <h2>How We Use Your Data</h2>
                        <p>Your personal data is used to provide the barbering services you've requested. This includes managing appointments, communicating with you about your booking, and processing payments. We may also use your information to inform you about promotions, new services, or updates if you opt into receiving such communications.</p>

                        <h2>Data Storage and Security</h2>
                        <p>Your personal data is stored securely in our database, with access granted only to authorized members of our team. We take reasonable steps to ensure that your data is stored and handled securely.</p>
                        <p>We will retain your personal data for the minimum legal retention period required by law, or for as long as is necessary to provide our services to you.</p>

                        <h2>Your Rights</h2>
                        <p>Under UK data protection laws, you have the following rights:</p>
                        <ul>
                        <li>The right to access the personal data we hold about you</li>
                        <li>The right to correct any inaccuracies in your data</li>
                        <li>The right to request the deletion of your data under certain circumstances</li>
                        <li>The right to object to the processing of your data for marketing purposes</li>
                        <li>The right to request the transfer of your data to another service provider</li>
                        </ul>
                        <p>If you would like to exercise any of these rights, please contact us at <strong>4wheelbarbers@yahoo.com</strong>.</p>

                        <h2>Changes to This Policy</h2>
                        <p>We may update this Privacy Policy from time to time. Any changes will be posted on our website, and where appropriate, you will be notified by email or text message.</p>

                        <h2>Contact Us</h2>
                        <p>If you have any questions about this Privacy Policy or the way we handle your data, please contact us at:</p>
                        <p>Email: <strong>4wheelbarbers@yahoo.com</strong></p>
                        <p>Phone: <strong>07756235725</strong></p>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default privacyPolicy;